import { render, staticRenderFns } from "./FormVouchers.vue?vue&type=template&id=56091fc0&"
import script from "./FormVouchers.vue?vue&type=script&lang=js&"
export * from "./FormVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports